import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    wall: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    isManager: PropTypes.bool.isRequired,
    handleOpenButton: PropTypes.func.isRequired,
  },
  handleDeleteButton() {
    this.props.handleOpenButton(this.props.wall.id);
  },
  render() {
    const { wall, isManager, currentUser } = this.props;
    if (!isManager && currentUser.id !== wall.user_id) {
      return "";
    }
    return (
      <div
        className="option-dot cursor-pointer"
        onClick={this.handleDeleteButton}
      >
        <a>
          <i className="fas fa-ellipsis-h" style={{ lineHeight: "35px" }} />
        </a>
      </div>
    );
  },
});
